import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiInput from './AiInput'

const mapStateToProps = (state, ownProps) => ({
  childrenE: state['options_'+ownProps.attr].options,
  optionE: state['options_'+ownProps.attr],
  sc: state.sc,
  loading:state.loading,
  lsbefore:state['lsbefore'],
  sku:state.sku,
  m:state.m,
  e1:state.e1,
  e2:state.e2,
  e3:state.e3,
  e4:state.e4,
  e5:state.e5,
  e6:state.e6,
  e7:state.e7,
  e8:state.e8,
  test:state.test,
  showpreview:state.showpreview
  

})


 

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick: ( () => dispatch(state_update({attr:ownProps.attr,value:ownProps.value}))),
  //onReqCharE1: ( () => dispatch(state_update({attr:"reqCharE1",value:"yes"}))),
  onLoadingDone: (() =>{ 
   // console.log('onLoadingDone')
  //  dispatch(state_update({attr:'showSticky',value:true}) )
    dispatch(state_update({attr:'loading',value:'done'}) )
  }
  ),
 
 // onClick: () =>state_update({attr:ownProps.attr,value:ownProps.value})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiInput)


// WEBPACK FOOTER //
// ./src/layout/AiInputWrap.js